import React, { ComponentType, useMemo } from 'react';
import BlockContext from '../../components/blocks/BlockContext';
import { ElementType } from '../../types/api/ElementType';
import BlockFetcher from '../../components/hocs/BlockFetcher/BlockFetcher';
import { ContentSearchResults } from '../../components/blocks/SearchResults';

const Blocks = {
  [ElementType.searchlist]: BlockFetcher()(ContentSearchResults as any),
};

const BlocksWithContext = Object.entries(Blocks).reduce<Record<string, ComponentType<{ uuid: string }>>>(
  (accumulator, [elementType, Block]) => {
    function BlockContextWrapper(props: { uuid: string }) {
      const value = useMemo(
        () => ({
          elementType: elementType as ElementType,
          uuid: props.uuid,
        }),
        [props.uuid]
      );
      return (
        <BlockContext.Provider value={value}>
          <Block {...props} />
        </BlockContext.Provider>
      );
    }

    return { ...accumulator, [elementType]: BlockContextWrapper };
  },
  {}
);

export default BlocksWithContext;
